module.exports = __webpack_public_path__ + "media/src/assets/Images/BackArrow-73ea02d575330d73a23815c04ac5cdfb.svg";